import {Injectable} from '@angular/core';
import {SafeResourceUrl} from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class ModelService {
    public user: Sofi.User = {
        address: '',
        brand: '-',
        carDealershipName: '',
        city: '',
        dealerCode: '',
        rciNetNumber: '',
        zipCode: ''
    };

    public salesman: Sofi.Salesman = {
        fax: '',
        firstName: '',
        name: '',
        phone: '',
        title: ''
    };

    // public customer: Sofi.Customer = {
    //     customerkind: '1',
    //     birthdate: '01.01.1978',
    //     firstName: 'Hans',
    //     name: 'Wurst',
    //     title: '1'
    // };
    public customer: Sofi.Customer = {
        customerkind: '',
        birthdate: '',
        firstName: '',
        name: '',
        title: ''
    };

    elvisUrl: SafeResourceUrl;

    constructor() {
    }
}
